import type { LinkProps as NextLinkProps } from 'next/link';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
interface LinkProps extends Omit<NextLinkProps, 'href'> {
  href: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}
export function LocaleLink({
  href,
  children,
  style,
  ...props
}: LinkProps) {
  const router = useRouter();
  const locale = router.locale ?? router.defaultLocale;
  return <NextLink href={href} locale={locale} style={{
    textDecoration: 'none',
    color: 'inherit',
    ...style
  }} {...props}>
      {children}
    </NextLink>;
}